import React, { Component, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
 
const CommonErrorPopup = (props) => {
return (
  <Modal {...props} className="common-popup" aria-labelledby="contained-modal-title-vcenter" centered>
    <section className='common-modal'>
      <a onClick={props.cError_closeBtn} className='close-icon' href='javascript:;' title='Close'>&nbsp;</a>
      <Modal.Body>
        <p>{props.state.commonErrorMsg}</p>
      </Modal.Body>
    </section>
  </Modal>
)}
export default CommonErrorPopup;